module.exports = __webpack_public_path__ + "assets/app8logo.d6850dae.svg";